/**
 * Created by Administrador on 17/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('modelAircrafts', {
                parent: 'app',
                url: '/modelAircrafts',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/modelAircraft/modelAircraft.html',
                        controller: 'modelAircraftsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['modelAircraft']);
                    }],
                    tabs: ['tabService', function (tabService) {
                        return tabService.getTabAircrafts('modelAircrafts');
                    }],
                    modelAircrafts: ['modelAircraftService', '$stateParams', function (modelAircraftService, $stateParams) {
                        return modelAircraftService.getPageModelAircrafts($stateParams.page, $stateParams.size);
                    }]
                }
            })
            .state('modelAircraftNew', {
                parent: 'app',
                url: '/modelAircraft/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/modelAircraft/newEditModelAircraft.html',
                        controller: 'newEditModelAircraftController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['modelAircraft', 'maker']);
                    }],
                    tabs: ['tabService', function (tabService) {
                        return tabService.getTabAircrafts('modelAircrafts');
                    }],
                    modelAircraft: [function () {
                        return null;
                    }],
                    makers: ['makerService', function (makerService) {
                        return makerService.getMakers();
                    }]
                }
            })
            .state('modelAircraftEdit', {
                parent: 'app',
                url: '/modelAircraft/:makerId/edit/:modelAircraftId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/modelAircraft/newEditModelAircraft.html',
                        controller: 'newEditModelAircraftController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['modelAircraft', 'maker']);
                    }],
                    tabs: ['tabService', function (tabService) {
                        return tabService.getTabAircrafts('modelAircrafts');
                    }],
                    modelAircraft: ['modelAircraftService', '$stateParams', function (modelAircraftService, $stateParams) {
                        return modelAircraftService.getModelAircraft($stateParams.makerId, $stateParams.modelAircraftId);
                    }],
                    makers: ['makerService', function (makerService) {
                        return makerService.getMakers();
                    }]
                }
            })
            .state('modelAircraftFlightTime', {
                parent: 'app',
                url: '/modelAircraft/:makerId/flightTime/:modelAircraftId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/modelAircraft/flightTimeModelAircraft.html',
                        controller: 'flightTimeModelAircraftCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['modelAircraft','airport']);
                            }],
                            'modelAircraft': ['modelAircraftService','$stateParams', function(modelAircraftService,$stateParams) {
                                return modelAircraftService.getModelAircraft($stateParams.makerId, $stateParams.modelAircraftId);
                            }],
                            'flightTimes': ['modelAircraftService','$stateParams', function(modelAircraftService,$stateParams) {
                                return modelAircraftService.getFlightTimes($stateParams.makerId, $stateParams.modelAircraftId);
                            }],
                            'takeOffCapacities': ['modelAircraftService','$stateParams', function(modelAircraftService,$stateParams) {
                                return modelAircraftService.getTakeOffCapacities($stateParams.makerId, $stateParams.modelAircraftId);
                            }]
                        }
                    }
                }
            })
            .state('modelAircraftDelete', {
                parent: 'modelAircrafts',
                url: '/modelAircraft/:makerId/delete/:modelAircraftId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/aircraft/modelAircraft/deleteModelAircraft.html',
                        controller: 'deleteModelAircraftController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['modelAircraft']);
                            }],
                            modelAircraft: ['modelAircraftService', function (modelAircraftService) {
                                return modelAircraftService.getModelAircraft($stateParams.makerId, $stateParams.modelAircraftId);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('modelAircrafts', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]

            });
    }
})();
